import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d4f12aa")

_pushScopeId("data-v-1d4f12aa")
const _hoisted_1 = { class: "container mt-3" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "My work", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-5" }, [
  /*#__PURE__*/_createTextVNode(" Choose your "),
  /*#__PURE__*/_createVNode("strong", null, "working hours"),
  /*#__PURE__*/_createTextVNode(" to let the team know when you'll be available ")
], -1)
const _hoisted_5 = {
  class: "calendar",
  ref: "calendarEl"
}
const _hoisted_6 = { class: "calendar-loader-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "calendar-loader"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Updating...")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "is-size-7 calendar-selection-info" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon has-text-info" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
  ]),
  /*#__PURE__*/_createTextVNode(" You can select multiple days by clicking and dragging. Weekends are not included in that selection ")
], -1)
const _hoisted_10 = { class: "tabs-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_unavailable_days = _resolveComponent("unavailable-days")
  const _component_tabs = _resolveComponent("tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, null, 512),
      _createVNode("div", _hoisted_6, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9,
      _createVNode(_Transition, { name: "quick-fade" }, {
        default: _withId(() => [
          _createVNode(_component_unavailable_days, { unavailableDays: _ctx.unavailableDays }, null, 8, ["unavailableDays"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_10, [
        _createVNode(_Transition, { name: "quick-fade" }, {
          default: _withId(() => [
            (!_ctx.isLoading && _ctx.selectedDays.length > 0)
              ? (_openBlock(), _createBlock(_component_tabs, {
                  key: 0,
                  selectedDays: _ctx.selectedDays,
                  selectedDay: _ctx.selectedDay,
                  "active-tab": _ctx.activeTab,
                  onActiveTabChange: _cache[1] || (_cache[1] = tab => (_ctx.activeTab = tab)),
                  onApplyToSelection: _ctx.applyToSelection,
                  onApplyNotAvailableToSelection: _ctx.applyNotAvailableToSelection,
                  onRemoveSelection: _ctx.removeSelection
                }, null, 8, ["selectedDays", "selectedDay", "active-tab", "onApplyToSelection", "onApplyNotAvailableToSelection", "onRemoveSelection"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
})